import { CSSProperties } from 'react';

import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import {
  closePlaylistDrawer,
  selectPlaylistDrawerStep,
  selectIsCurrentPlaylistSuggested,
} from '@backrs_ui/grow-ui/src/redux/priorities/priorities.slice';

import { SxProps, Theme, Drawer, Box } from '@mui/material';

import { PlaylistListDrawer } from './PlaylistListDrawer';
import { PlaylistViewDrawer } from './PlaylistViewDrawer';
import { TemplateViewDrawer } from './TemplateViewDrawer';
import { DRAWER_MAX_WIDTH } from '../constants/priorities.constants';

export const PlaylistsDrawer = () => {
  const playlistDrawerStep = useAppSelector(selectPlaylistDrawerStep);
  const isCurrentPlaylistSuggested = useAppSelector(selectIsCurrentPlaylistSuggested);

  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(closePlaylistDrawer());
  };

  const playlistViewStep = isCurrentPlaylistSuggested ? (
    <TemplateViewDrawer handleClose={handleClose} />
  ) : (
    <PlaylistViewDrawer handleClose={handleClose} />
  );

  return (
    <Drawer
      anchor="right"
      open={!!playlistDrawerStep}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          style: drawerBackdropPropsSx,
        },
      }}
      ModalProps={{
        keepMounted: true,
        disableEnforceFocus: true,
        disableAutoFocus: true,
        disableRestoreFocus: true,
      }}
      PaperProps={{
        sx: drawerPaperPropsSx,
      }}
    >
      <Box sx={containerSx}>
        {playlistDrawerStep?.step === 'LIST' && <PlaylistListDrawer handleClose={handleClose} />}

        {playlistDrawerStep?.step === 'VIEW' && playlistViewStep}
      </Box>
    </Drawer>
  );
};

const drawerPaperPropsSx: SxProps<Theme> = ({ backrs }) => ({
  boxShadow: 'none',
  borderLeft: `1px solid ${backrs.colors['Colors/Foreground/fg-primary']}`,
});

const drawerBackdropPropsSx: CSSProperties = {
  backgroundColor: 'transparent',
  boxShadow: 'none',
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Base/White'],
  // to handle the hover animation of the playlist cards, we need to subtract the padding of the playlist card container
  paddingX: `calc(${backrs.spacing['spacing-3xl']} - ${backrs.spacing['spacing-sm']})`,
  paddingTop: backrs.spacing['spacing-lg'],
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',

  minWidth: {
    xs: `calc(100vw - (${backrs.spacing['spacing-4xl']}))`,
    sm: `${DRAWER_MAX_WIDTH}px`,
  },
  maxWidth: { sm: `${DRAWER_MAX_WIDTH}px` },
});
